import { ChevronLeft } from 'lucide-react'

interface StepHeaderProps {
  title: string
  onBack?: () => void
}

export function StepHeader({ title, onBack }: StepHeaderProps) {
  return (
    <div className="mb-6 flex items-center gap-3">
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="flex size-9 shrink-0 items-center justify-center rounded-full bg-white/70 shadow-sm active:scale-95"
        >
          <ChevronLeft className="size-5" />
        </button>
      )}
      <h2 className="font-serif text-2xl font-medium">{title}</h2>
    </div>
  )
}
